<div class="formulaCustomFields">
  {{ 'custom_fields' | ppTranslate }}:

  @for (customField of customFields; track customField) {
    <pp-formula-piece
      class="formulaCustomField"
      [ppDisabled]="disabled"
      [class.formulaCustomField__disabled]="disabled"
      [ppWorkspaceId]="ppWorkspaceId"
      [ppFormulaPiece]="customField"
      (ppAction)="addCustomField(customField)"
      [ppClickable]="true"
    ></pp-formula-piece>
  }
</div>
